@let checkIn = checkInFeature.selectors.checkIn.asSignal();
@let ignoreCheckInPrompt =
  checkInFeature.selectors.ignoreCheckInPrompt.asSignal();
@let responseToTheResponse =
  checkInFeature.selectors.responseToTheResponse.asSignal();
@let checkInOrResponseToTheResponseIsLoading =
  checkInFeature.selectors.checkInOrResponseToTheResponseIsLoading.asSignal();

<atn-ds-centered-overlay
  (backdropClick)="
    checkInFeature.actions.stopCheckIn
      .from('CheckInModal.Backdrop.Clicked')
      .dispatch()
  "
>
  <atn-ds-widget title="Quick Check-In">
    <i
      class="atn-icon atn-close atn-red"
      actions
      (click)="
        checkInFeature.actions.stopCheckIn
          .from('CheckInModal.CloseButton.Clicked')
          .dispatch()
      "
    ></i>

    <div class="atn-check-in-modal__body">
      @if (checkInOrResponseToTheResponseIsLoading) {
        <atn-ds-loader />
      } @else if (checkIn) {
        <atn-check-in-modal-content />
      } @else if (responseToTheResponse) {
        <!-- NOTE: disabling prettier because it wraps to new lines which
          causes spaces to be displayed in the result -->
        <!-- prettier-ignore -->
        <p class="atn-check-in-modal__response-to-the-response">{{ responseToTheResponse }}</p>
      }
    </div>

    <div
      class="atn-check-in-modal__footer"
      footer
    >
      @if (checkIn) {
        <a
          class="atn-check-in-modal__prompt-toggle"
          (click)="
            checkInFeature.actions.setIgnoreCheckInPrompt
              .from('CheckInModal.PromptToggle.Clicked')
              .dispatch('toggle')
          "
        >
          {{ ignoreCheckInPrompt ? 'Use' : 'Ignore' }} Prompt
        </a>
      }
      <atn-ds-button
        class="atn-check-in-modal__submit-button"
        (click)="
          checkInFeature.actions[
            checkIn ? 'submitResponse' : 'acknowledgeResponseToTheResponse'
          ]
            .from('CheckInModal.SubmitButton.Clicked')
            .dispatch()
        "
      >
        @if (checkIn) {
          Submit
        } @else {
          Done
        }
      </atn-ds-button>
    </div>
  </atn-ds-widget>
</atn-ds-centered-overlay>
